import {
  TaxonomyTargetAudience,
  TaxonomyLocation,
  TaxonomyTheme,
} from '../implementations';

const mappers = {
  locations: TaxonomyLocation,
  themes: TaxonomyTheme,
  target_audiences: TaxonomyTargetAudience,
};

export default mappers;
